@if (data.infoText?.title) {
  <h1 mat-dialog-title>{{ data.infoText?.title }}</h1>
}
<mat-dialog-content>
  <div>
    <div class="row g-3">
      <div class="col-12 line-breaks" [innerHTML]="data.infoText?.descriptionLong ?? data.infoText?.descriptionShort">
      </div>
      @if (data.infoText?.linkUrl) {
        <div class="col-12">
          @if (data.infoText?.linkName) {
            <a [href]="data.infoText?.linkUrl" target="_blank">{{ data.infoText?.linkName }}</a>
          } @else {
            <a [href]="data.infoText?.linkUrl" target="_blank">{{ data.infoText?.linkUrl }}</a>
          }
        </div>
      }
      @if (data.infoText?.infoFile) {
        <div class="col-12">
          <span class="link-text cursor-pointer" (click)="downloadInfoFile()">
            {{ data.infoText?.infoFile?.filename }}
          </span>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
